const frontierModules = [
  ["cms-frontier/buyability", "buyability-sub-app/CMSBuyAbility"]
  // Future team registrations:
  // ['mortgage-team/rate-calculator', 'mortgage-sub-app/RateCalculator'],
  // ['rental-team/listing-card', 'rental-sub-app/ListingCard'],
];
export {
  frontierModules
};
